import { OrganizationMember } from '@/@types/client-api';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import creditTrackerAdminEndpoints from '../api/client/creditTrackerAdmin';

export interface CreditTrackerAdminState {
  organization: Record<string, Array<OrganizationMember>>;
}

const initialState: CreditTrackerAdminState = {
  organization: {}
};

export const creditTrackerAdminSlice = createSlice({
  name: 'creditTrackerAdmin',
  initialState,
  reducers: {
    creditTrackerAdminGetMemberSuccess: (
      state,
      action: PayloadAction<{
        request: number;
        response: Record<string, Array<OrganizationMember>>;
      }>
    ) => {
      const orgSk = action.payload.request.toString();
      if (orgSk) {
        for (const key in action.payload.response) {
          state.organization[orgSk] = action.payload.response[key];
        }
      }
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      creditTrackerAdminEndpoints.endpoints.getIndividualRosterMember.matchFulfilled,
      (state, action) => {
        const orgSk = action.meta.arg.originalArgs.orgSk;
        if (orgSk) {
          state.organization[orgSk] = action.payload.members ?? [];
        }
      }
    );
  }
});

export const { creditTrackerAdminGetMemberSuccess } = creditTrackerAdminSlice.actions;

export default creditTrackerAdminSlice.reducer;
